import React from 'react'
import { Checkbox, Row, Col, Input, Button, message, Popconfirm } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import _ from 'lodash'

import { connect } from 'react-redux'
import { setCategories } from '@/store/actions'

@connect(
  state => ({
    categories: state.categories
  }),
  { setCategories }
)
class CategoryEdit extends React.Component {
  constructor (props) {
    super(props)
    this.InputChild = React.createRef() // 此处初始化

    this.state = {
      editIndex: null,
      editTempName: '',
      cats: [],
      hoverIndex: null,
      newCatName: ''
    }
  }

  componentDidMount () {
    this.setState({
      cats: this.props.categories,
    })
  }

  updateCategories = () => {
    this.props.setCategories(this.state.cats)
  }

  editCat = (index) => {
    const oldName = this.state.cats[index].title
    this.setState(
      {
        editIndex: index,
        editTempName: oldName
      },
      () => {
        this.InputChild.current.focus()
        this.InputChild.current.select()
      }
    )
  }

  // 修改名称
  inputOnBlur = () => {
    const { state } = this

    if (!state.editTempName) {
      message.warning('分类名称不能为空')
      this.setState({ editIndex: null })
      return
    }

    this.setState((prevState) => {
      const newCats = [ ...prevState.cats ]
      newCats[prevState.editIndex].title = state.editTempName
      return {
        cats: newCats,
        editIndex: null
      }
    }, this.updateCategories)
  }

  // 删除
  confirmDel = (index) => {
    this.setState((prevState) => {
      const newCats = [ ...prevState.cats ]
      newCats.splice(index, 1)
      return {
        cats: newCats,
        hoverIndex: null
      }
    }, this.updateCategories)
  }

  changeCatName = (key, e) => {
    this.setState({
      [key]: e.target.value
    })
  }

  changeCatCheck = (id) => {
    if (this.props.multi === false) {
      this.props.onChange([id])
      return
    }

    const { selectedArr } = this.props

    const hasIndex = selectedArr.indexOf(id)

    const newSelectCats = [ ...selectedArr ]

    if (hasIndex > -1) {
      newSelectCats.splice(hasIndex, 1)
    } else {
      newSelectCats.push(id)
    }

    this.props.onChange(newSelectCats)
  }

  // 保存名称
  saveNewName = () => {
    const { newCatName, cats } = this.state

    if (!newCatName) {
      message.error('请输入新名')
      return
    }

    const hasIndex = _.findIndex(cats, { title: newCatName })
    if (hasIndex > -1) {
      message.error('重复')
      return
    }

    const newItem = { title: newCatName }

    this.setState((prevState) => {
      const oldCats = [ ...prevState.cats ]
      oldCats.push(newItem)

      return {
        cats: oldCats,
        newCatName: ''
      }
    }, this.updateCategories)
  }

  render () {
    const { editCat, changeCatName, inputOnBlur, confirmDel, saveNewName, changeCatCheck, state } = this
    const { cats, editTempName, editIndex, hoverIndex, newCatName } = state
    const { selectedArr } = this.props

    return (
      <div className="category-editor-container">
        <Row gutter={16}>
          <Col span={24}>
            <Row gutter={16}>
              <Col span={24}>
                <ul className="category-items">
                  {
                    cats.map((item, index) => (
                      <li
                        key={item.id}
                        className="category-item"
                        onMouseEnter={() => this.setState({ hoverIndex: index })}
                        onMouseLeave={() => this.setState({ hoverIndex: null })}
                      >
                        <div>
                          {
                            editIndex === index
                              ? <div>
                                  <Input
                                    value={editTempName}
                                    onChange={e => changeCatName('editTempName', e)}
                                    onBlur={inputOnBlur}
                                    ref={this.InputChild}
                                  />
                                </div>
                              : <div>
                                <Checkbox checked={selectedArr.includes(item.id)} onChange={() => changeCatCheck(item.id)} />
                                <span style={{ marginLeft: '10px' }} onClick={() => editCat(index)}>
                                  {item.title}
                                </span>
                              </div>
                          }
                        </div>
                        {
                          editIndex === null && hoverIndex === index && (
                            <Popconfirm placement="topLeft" title="确认删除?" onConfirm={() => confirmDel(index)} okText="是的" cancelText="点错了">
                              <DeleteOutlined className="del-btn" />
                            </Popconfirm>
                          )
                        }
                      </li>
                    ))
                  }
                </ul>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={20}>
                <Input
                  value={newCatName}
                  onChange={e => changeCatName('newCatName', e)}
                />
              </Col>
              <Col span={4}>
                <Button onClick={saveNewName}>
                  <PlusOutlined />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default CategoryEdit
